import type { Options } from 'ky';

import type { ApiOptions } from './ApiProvider';
import Api from './ApiProvider';
import type { GetPerksListSearchParams, PerksList } from './types';

export const GET_PERKS_LIST_DEFAULT_LIMIT = 12;

export const getPerksList = (options?: ApiOptions<{ searchParams?: GetPerksListSearchParams }>) => {
  const optionsWithDefaults: Options = {
    cache: 'no-store',
    ...options,
    searchParams: {
      limit: GET_PERKS_LIST_DEFAULT_LIMIT,
      ...options?.searchParams,
    },
  };

  return Api.get('v2/store/perks', optionsWithDefaults).json<PerksList>();
};
